// Check if IntersectionObserver is supported
function lazyLoadPLPVideos() {

  const lazyVideos = document.querySelectorAll('video[data-src]:not([data-loaded])');

  // Create the observer with a root margin to start loading earlier
  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const src = video.getAttribute('data-src');
        video.querySelector('source').src = src;
        video.setAttribute('data-loaded','true')
        video.load(); // Load the video only when it enters the threshold
        observer.unobserve(video); // Stop observing once the video has loaded
      }
    });
  }, { rootMargin: '500px' }); // Start loading 200px before the video enters viewport

  lazyVideos.forEach(video => {
    videoObserver.observe(video);
  });
}
lazyLoadPLPVideos();